 
import EstimationAndJobForm from '../common/EstimationAndJob/EstimationAndJobForm';
  
const EstimationTemplateForm = () => {
  return (
    <EstimationAndJobForm type="estimation_template" />
  )
}
export default EstimationTemplateForm;